import React from 'react'
import { StyledLabel, StyledValue, StyledWrapperBox } from './styles/style'
import { object } from 'prop-types'

const InternalDatabaseFieldText = ({ data }) => {
	return (
		<>
			{data.field.label && <StyledLabel>{data.field.label}:</StyledLabel>}
			<StyledWrapperBox>
				{data.value.map((row) => (
					<StyledValue key={row.id}>
						{`- ${
							data.field.typeWidget === 'checkbox'
								? row.data[0].value
								: row.description
						}`}
					</StyledValue>
				))}
			</StyledWrapperBox>
		</>
	)
}

InternalDatabaseFieldText.propTypes = {
	data: object,
}

export default InternalDatabaseFieldText
